// AUTO-GENERATED by backend/scripts/gen_home_i18n.py — do not edit by hand.
// Homepage SeoContent + CustomerRatings + ChatWidget + GoogleProfileCard copy (en + 12 more langs; de stays in the component).
export const SEO_CONTENT = {
 "en": {
  "h2a": "Your airport transfer from Zurich Airport",
  "p1": "Zuerich Airport Taxi is your specialist provider for airport transfers and airport taxi service at Zurich Airport (ZRH). We take you on time, safely and comfortably all across Switzerland – at clear fixed prices and with professional chauffeurs. Whether business trip, family holiday or ski vacation: your private transfer from Zurich Airport is booked in under a minute.",
  "h2b": "Zurich Airport Taxi at fixed prices – no hidden costs",
  "p2": "Unlike an ordinary taxi at Zurich Airport, you pay a guaranteed fixed price that you see before you book. No taximeter, no surprises. Thanks to free flight tracking we automatically adjust the pickup time to your actual landing – and we wait for you free of charge, even if your flight is delayed.",
  "h2c": "Popular transfer routes from Zurich Airport",
  "h2d": "Why Zuerich Airport Taxi?",
  "feats": [
   "Guaranteed fixed prices from CHF 70",
   "Free flight tracking & waiting time",
   "Professional chauffeurs, modern Mercedes fleet",
   "Transfers to 6 countries: Switzerland, Germany, Italy, Austria, France, Liechtenstein",
   "Available 24/7 – also at night & on holidays",
   "Pay by card, Apple Pay, Google Pay or cash"
  ],
  "cta_prices": "View all prices",
  "cta_cities": "All cities & routes"
 },
 "fr": {
  "h2a": "Votre transfert d'aéroport depuis l'aéroport de Zurich",
  "p1": "Zuerich Airport Taxi est votre fournisseur spécialisé pour les transferts d'aéroport et le service de taxi à l'aéroport de Zurich (ZRH). Nous vous emmenons à temps, en toute sécurité et confortablement à travers toute la Suisse – à des prix fixes clairs et avec des chauffeurs professionnels. Que ce soit pour un voyage d'affaires, des vacances en famille ou des vacances de ski : votre transfert privé depuis l'aéroport de Zurich est réservé en moins d'une minute.",
  "h2b": "Taxi de l'aéroport de Zurich à des prix fixes – pas de coûts cachés",
  "p2": "Contrairement à un taxi ordinaire à l'aéroport de Zurich, vous payez un prix fixe garanti que vous voyez avant de réserver. Pas de taximètre, pas de surprises. Grâce au suivi de vol gratuit, nous ajustons automatiquement l'heure de ramassage à votre atterrissage réel – et nous vous attendons gratuitement, même si votre vol a du retard.",
  "h2c": "Routes de transfert populaires depuis l'aéroport de Zurich",
  "h2d": "Pourquoi choisir Zuerich Airport Taxi ?",
  "feats": [
   "Prix fixes garantis à partir de CHF 70",
   "Suivi de vol gratuit & temps d'attente",
   "Chauffeurs professionnels, flotte moderne de Mercedes",
   "Transferts vers 6 pays : Suisse, Allemagne, Italie, Autriche, France, Liechtenstein",
   "Disponible 24/7 – aussi la nuit & les jours fériés",
   "Paiement par carte, Apple Pay, Google Pay ou en espèces"
  ],
  "cta_prices": "Voir tous les prix",
  "cta_cities": "Toutes les villes & routes"
 },
 "it": {
  "h2a": "Il tuo trasferimento aeroportuale da Zurigo",
  "p1": "Zuerich Airport Taxi è il tuo fornitore specializzato per trasferimenti aeroportuali e servizio taxi aeroportuale all'Aeroporto di Zurigo (ZRH). Ti portiamo in tempo, in sicurezza e comodamente in tutta la Svizzera – a prezzi fissi chiari e con autisti professionisti. Che si tratti di un viaggio di lavoro, una vacanza in famiglia o una vacanza sciistica: il tuo trasferimento privato dall'Aeroporto di Zurigo è prenotato in meno di un minuto.",
  "h2b": "Taxi Aeroporto di Zurigo a prezzi fissi – senza costi nascosti",
  "p2": "A differenza di un taxi ordinario all'Aeroporto di Zurigo, paghi un prezzo fisso garantito che vedi prima di prenotare. Nessun tassametro, nessuna sorpresa. Grazie al monitoraggio gratuito dei voli, adatteremo automaticamente l'orario di prelievo al tuo atterraggio effettivo – e ti aspettiamo gratuitamente, anche se il tuo volo è in ritardo.",
  "h2c": "Percorsi di trasferimento popolari dall'Aeroporto di Zurigo",
  "h2d": "Perché Zuerich Airport Taxi?",
  "feats": [
   "Prezzi fissi garantiti a partire da CHF 70",
   "Monitoraggio voli gratuito e tempo di attesa",
   "Autisti professionisti, flotta moderna di Mercedes",
   "Trasferimenti in 6 paesi: Svizzera, Germania, Italia, Austria, Francia, Liechtenstein",
   "Disponibile 24/7 – anche di notte e nei giorni festivi",
   "Paga con carta, Apple Pay, Google Pay o contanti"
  ],
  "cta_prices": "Visualizza tutti i prezzi",
  "cta_cities": "Tutte le città e i percorsi"
 },
 "es": {
  "h2a": "Su traslado desde el Aeropuerto de Zúrich",
  "p1": "Zuerich Airport Taxi es su proveedor especializado en traslados y servicio de taxi en el Aeropuerto de Zúrich (ZRH). Lo llevamos a tiempo, de forma segura y cómoda a lo largo de Suiza – a precios fijos claros y con chóferes profesionales. Ya sea un viaje de negocios, unas vacaciones familiares o unas vacaciones de esquí: su traslado privado desde el Aeropuerto de Zúrich se reserva en menos de un minuto.",
  "h2b": "Zuerich Airport Taxi a precios fijos – sin costos ocultos",
  "p2": "A diferencia de un taxi ordinario en el Aeropuerto de Zúrich, paga un precio fijo garantizado que ve antes de reservar. Sin taxímetro, sin sorpresas. Gracias al seguimiento de vuelos gratuito, ajustamos automáticamente la hora de recogida a su aterrizaje real – y lo esperamos sin cargo, incluso si su vuelo se retrasa.",
  "h2c": "Rutas de traslado populares desde el Aeropuerto de Zúrich",
  "h2d": "¿Por qué Zuerich Airport Taxi?",
  "feats": [
   "Precios fijos garantizados desde CHF 70",
   "Seguimiento de vuelos gratuito y tiempo de espera",
   "Chóferes profesionales, flota moderna de Mercedes",
   "Traslados a 6 países: Suiza, Alemania, Italia, Austria, Francia, Liechtenstein",
   "Disponible 24/7 – también de noche y en días festivos",
   "Pague con tarjeta, Apple Pay, Google Pay o efectivo"
  ],
  "cta_prices": "Ver todos los precios",
  "cta_cities": "Todas las ciudades y rutas"
 },
 "pt": {
  "h2a": "Seu traslado do aeroporto de Zurique",
  "p1": "Zuerich Airport Taxi é seu provedor especializado para traslados de aeroporto e serviço de táxi no Aeroporto de Zurique (ZRH). Levamos você pontualmente, com segurança e conforto por toda a Suíça – com preços fixos claros e motoristas profissionais. Seja em viagem de negócios, férias em família ou férias de esqui: seu traslado privado do Aeroporto de Zurique é reservado em menos de um minuto.",
  "h2b": "Zuerich Airport Taxi a preços fixos – sem custos ocultos",
  "p2": "Diferente de um táxi comum no Aeroporto de Zurique, você paga um preço fixo garantido que você vê antes de reservar. Sem taxímetro, sem surpresas. Graças ao rastreamento de voos gratuito, ajustamos automaticamente o horário de coleta ao seu pouso real – e esperamos por você gratuitamente, mesmo que seu voo tenha atraso.",
  "h2c": "Rotas de traslado populares do Aeroporto de Zurique",
  "h2d": "Por que escolher Zuerich Airport Taxi?",
  "feats": [
   "Preços fixos garantidos a partir de CHF 70",
   "Rastreamento de voos gratuito e tempo de espera",
   "Motoristas profissionais, frota moderna de Mercedes",
   "Traslados para 6 países: Suíça, Alemanha, Itália, Áustria, França, Liechtenstein",
   "Disponível 24/7 – também à noite e em feriados",
   "Pagamento por cartão, Apple Pay, Google Pay ou dinheiro"
  ],
  "cta_prices": "Ver todos os preços",
  "cta_cities": "Todas as cidades e rotas"
 },
 "tr": {
  "h2a": "Zürih Havalimanı'ndan transferiniz",
  "p1": "Zuerich Airport Taxi, Zürih Havalimanı (ZRH) için havalimanı transferleri ve havalimanı taksi hizmetinin uzman sağlayıcısıdır. Sizi zamanında, güvenli ve konforlu bir şekilde İsviçre'nin her yerine götürüyoruz - net sabit fiyatlarla ve profesyonel şoförlerle. İş seyahati, aile tatili veya kayak tatili olsun: Zürih Havalimanı'ndan özel transferiniz bir dakikadan kısa sürede rezervasyon yapılabilir.",
  "h2b": "Sabit fiyatlarla Zuerich Airport Taxi - gizli maliyet yok",
  "p2": "Zürih Havalimanı'ndaki sıradan bir taksiden farklı olarak, rezervasyon yapmadan önce görebileceğiniz garantili bir sabit fiyat ödüyorsunuz. Taksimetre yok, sürpriz yok. Ücretsiz uçuş takibi sayesinde, alım saatini gerçek inişinize otomatik olarak ayarlıyoruz - hatta uçağınız gecikirse bile sizin için ücretsiz bekliyoruz.",
  "h2c": "Zürih Havalimanı'ndan popüler transfer rotaları",
  "h2d": "Neden Zuerich Airport Taxi?",
  "feats": [
   "CHF 70'dan başlayan garantili sabit fiyatlar",
   "Ücretsiz uçuş takibi ve bekleme süresi",
   "Profesyonel şoförler, modern Mercedes filosu",
   "6 ülkeye transfer: İsviçre, Almanya, İtalya, Avusturya, Fransa, Lihtenştayn",
   "7/24 mevcut - gece ve tatil günlerinde de",
   "Kredi kartı, Apple Pay, Google Pay veya nakit ile ödeme"
  ],
  "cta_prices": "Tüm fiyatları görüntüle",
  "cta_cities": "Tüm şehirler ve yollar"
 },
 "ru": {
  "h2a": "Ваш трансфер из аэропорта Цюриха",
  "p1": "Zuerich Airport Taxi – ваш специализированный провайдер трансферов и такси в аэропорту Цюриха (ZRH). Мы отвезем вас вовремя, безопасно и комфортно по всей Швейцарии – по прозрачным фиксированным ценам и с профессиональными шоферами. Независимо от того, деловая поездка, семейный отдых или лыжный отпуск: ваш частный трансфер из аэропорта Цюриха можно забронировать за минуту.",
  "h2b": "Такси из аэропорта Цюриха по фиксированным ценам – без скрытых платежей",
  "p2": "В отличие от обычного такси в аэропорту Цюриха, вы платите гарантированную фиксированную цену, которую видите перед бронированием. Без таксометра, без сюрпризов. Благодаря бесплатному отслеживанию рейсов мы автоматически подстраиваем время встречи под ваше фактическое приземление – и ждем вас бесплатно, даже если ваш рейс задерживается.",
  "h2c": "Популярные маршруты трансфера из аэропорта Цюриха",
  "h2d": "Почему Zuerich Airport Taxi?",
  "feats": [
   "Гарантированные фиксированные цены от CHF 70",
   "Бесплатное отслеживание рейсов и время ожидания",
   "Профессиональные шоферы, современный автопарк Mercedes",
   "Трансферы в 6 стран: Швейцария, Германия, Италия, Австрия, Франция, Лихтенштейн",
   "Доступны 24/7 – также ночью и в праздничные дни",
   "Оплата картой, Apple Pay, Google Pay или наличными"
  ],
  "cta_prices": "Посмотреть все цены",
  "cta_cities": "Все города и маршруты"
 },
 "ar": {
  "h2a": "نقل المطار الخاص بك من مطار زيورخ",
  "p1": "تعتبر Zuerich Airport Taxi مزودك المتخصص في خدمات نقل المطار وخدمات سيارات الأجرة في مطار زيورخ (ZRH). نأخذك في الوقت المحدد، بأمان وراحة في جميع أنحاء سويسرا - بأسعار ثابتة واضحة ومع سائقين محترفين. سواء كانت رحلة عمل، إجازة عائلية أو إجازة تزلج: يتم حجز نقلك الخاص من مطار زيورخ في أقل من دقيقة.",
  "h2b": "سيارة الأجرة في مطار زيورخ بأسعار ثابتة - بدون تكاليف مخفية",
  "p2": "على عكس سيارة الأجرة العادية في مطار زيورخ، تدفع سعراً ثابتاً مضموناً تراه قبل الحجز. لا عداد، لا مفاجآت. بفضل تتبع الرحلات المجاني، نقوم بضبط وقت الاستلام تلقائياً وفقاً لوقت هبوطك الفعلي - وننتظرك مجاناً، حتى إذا تأخرت رحلتك.",
  "h2c": "طرق النقل الشائعة من مطار زيورخ",
  "h2d": "لماذا Zuerich Airport Taxi؟",
  "feats": [
   "أسعار ثابتة مضمونة تبدأ من CHF 70",
   "تتبع الرحلات المجاني ووقت الانتظار",
   "سائقون محترفون، أسطول حديث من سيارات Mercedes",
   "نقل إلى 6 دول: سويسرا، ألمانيا، إيطاليا، النمسا، فرنسا، ليختنشتاين",
   "متاح على مدار الساعة طوال أيام الأسبوع - أيضاً في الليل وأيام العطل",
   "الدفع بالبطاقة، Apple Pay، Google Pay أو نقداً"
  ],
  "cta_prices": "عرض جميع الأسعار",
  "cta_cities": "جميع المدن والمسارات"
 },
 "fa": {
  "h2a": "انتقال فرودگاهی شما از فرودگاه زوریخ",
  "p1": "زوریخ فرودگاهی تاکسی ارائه دهنده تخصصی خدمات انتقال فرودگاهی و تاکسی فرودگاهی در فرودگاه زوریخ (ZRH) است. ما شما را به موقع، با ایمنی و راحتی در سرتاسر سوئیس با قیمت‌های ثابت و شفاف و با رانندگان حرفه‌ای منتقل می‌کنیم. چه سفر کاری، تعطیلات خانوادگی یا تعطیلات اسکی: انتقال خصوصی شما از فرودگاه زوریخ در کمتر از یک دقیقه رزرو می‌شود.",
  "h2b": "زوریخ فرودگاهی تاکسی با قیمت‌های ثابت – بدون هزینه پنهان",
  "p2": "برخلاف تاکسی معمولی در فرودگاه زوریخ، شما قیمت ثابت ضمانت شده‌ای را پرداخت می‌کنید که قبل از رزرو مشاهده می‌کنید. هیچ تاکسی‌متر، هیچ سورپرایزی. به لطف ردیابی پرواز رایگان، ما زمان pickup را به زمان واقعی فرود شما تنظیم می‌کنیم – و حتی اگر پرواز شما تأخیر داشته باشد، به صورت رایگان برای شما منتظر می‌مانیم.",
  "h2c": "مسیرهای انتقال محبوب از فرودگاه زوریخ",
  "h2d": "چرا زوریخ فرودگاهی تاکسی؟",
  "feats": [
   "قیمت‌های ثابت ضمانت شده از CHF 70",
   "ردیابی پرواز رایگان و زمان انتظار",
   "رانندگان حرفه‌ای، ناوگان مدرن مرسدس",
   "انتقالات به 6 کشور: سوئیس، آلمان، ایتالیا، اتریش، فرانسه، لیختنشتاین",
   "در دسترس 24/7 – همچنین در شب و تعطیلات",
   "پرداخت با کارت، اپل پی، گوگل پی یا نقدی"
  ],
  "cta_prices": "نمایش همه قیمت‌ها",
  "cta_cities": "همه شهرها و مسیرها"
 },
 "hi": {
  "h2a": "चालक सेवा आपके ज़्यूरिख हवाई अड्डे से",
  "p1": "ज़्यूरिच एयरपोर्ट टैक्सी आपके ज़्यूरिख हवाई अड्डे (ZRH) पर हवाई अड्डे के ट्रांसफर और टैक्सी सेवा के लिए आपका विशेष प्रदाता है। हम आपको समय पर, सुरक्षित और आरामदायक तरीके से पूरे स्विट्ज़रलैंड में ले जाते हैं – स्पष्ट निश्चित कीमतों पर और पेशेवर चालकों के साथ। चाहे व्यावसायिक यात्रा हो, पारिवारिक अवकाश या स्की छुट्टी: आपके ज़्यूरिख एयरपोर्ट से निजी ट्रांसफर को एक मिनट से भी कम समय में बुक किया जा सकता है।",
  "h2b": "ज़्यूरिच एयरपोर्ट टैक्सी - निश्चित कीमतों पर – कोई छिपी हुई लागत नहीं",
  "p2": "ज़्यूरिच एयरपोर्ट पर आम टैक्सी के विपरीत, आप एक सुनिश्चित निश्चित मूल्य का भुगतान करते हैं जो आपको बुक करने से पहले दिखता है। कोई मीटर नहीं, कोई आश्चर्य नहीं। फ्री फ्लाइट ट्रैकिंग के लिए धन्यवाद, हम स्वचालित रूप से पिकअप समय को आपके वास्तविक उतरने के समय के अनुसार समायोजित करते हैं - और हम आपके लिए मुफ्त में इंतजार करते हैं, भले ही आपकी फ़्लाइट में देरी हो।",
  "h2c": "ज़्यूरिच एयरपोर्ट से लोकप्रिय ट्रांसफर मार्ग",
  "h2d": "क्यों ज़्यूरिच एयरपोर्ट टैक्सी?",
  "feats": [
   "CHF 70 से सुनिश्चित निश्चित कीमतें",
   "फ्री फ्लाइट ट्रैकिंग और प्रतीक्षा समय",
   "पेशेवर चालक, आधुनिक मर्सिडीज बेड़ा",
   "6 देशों के लिए ट्रांसफर: स्विट्ज़रलैंड, जर्मनी, इटली, ऑस्ट्रिया, फ्रांस, लिकटेनस्टाइन",
   "24/7 उपलब्ध – रात में और छुट्टियों पर भी",
   "कार्ड, एप्पल पे, गूगल पे या नकद से भुगतान करें"
  ],
  "cta_prices": "सभी कीमतें देखें",
  "cta_cities": "सभी शहर और मार्ग"
 },
 "zh": {
  "h2a": "您从苏黎世机场的机场接送",
  "p1": "苏黎世机场出租车是您在苏黎世机场 (ZRH) 进行机场接送和出租车服务的专业提供商。我们准时、安全、舒适地带您走遍整个瑞士 – 价格透明固定，专业司机服务。无论是商务旅行、家庭度假或滑雪假期：您从苏黎世机场的私人接送在一分钟内即可预订。",
  "h2b": "苏黎世机场出租车的固定价格 – 无隐藏费用",
  "p2": "与苏黎世机场的普通出租车不同，您支付的价格是您在预订前看到的保证固定价格。没有计价器，没有惊喜。由于免费的航班跟踪，我们会自动调整接机时间以符合您的实际降落时间 – 即使您的航班延误，我们也会免费等您。",
  "h2c": "从苏黎世机场出发的热门接送路线",
  "h2d": "为什么选择苏黎世机场出租车？",
  "feats": [
   "保证固定价格从 CHF 70 起",
   "免费的航班跟踪和等候时间",
   "专业司机，现代的梅赛德斯车队",
   "可接送至6个国家：瑞士、德国、意大利、奥地利、法国、列支敦士登",
   "全天候服务 – 包括夜间和假期",
   "可使用信用卡、Apple Pay、Google Pay 或现金支付"
  ],
  "cta_prices": "查看所有价格",
  "cta_cities": "所有城市和路线"
 },
 "ko": {
  "h2a": "취리히 공항에서의 공항 셔틀 서비스",
  "p1": "취리히 공항 택시는 취리히 공항(ZRH)에서의 공항 셔틀 서비스 및 공항 택시 서비스의 전문 제공업체입니다. 저희는 스위스 전역을 시간에 맞추어, 안전하고 편안하게 모십니다 – 명확한 고정 요금과 전문 운전사와 함께. 비즈니스 출장, 가족 휴가 또는 스키 휴양에 관계없이: 취리히 공항에서의 개인 셔틀 서비스는 1분 내에 예약됩니다.",
  "h2b": "고정 요금의 취리히 공항 택시 – 숨겨진 비용 없음",
  "p2": "취리히 공항의 일반 택시와 달리, 예약하기 전에 보실 수 있는 보장된 고정 요금을 지불합니다. 미터기 없음, 놀라움 없음. 무료 항공편 추적 덕분에 우리는 실제 착륙 시간에 맞춰 픽업 시간을 자동으로 조정하며, 비행기가 지연되더라도 무료로 기다립니다.",
  "h2c": "취리히 공항에서의 인기 셔틀 노선",
  "h2d": "왜 취리히 공항 택시인가요?",
  "feats": [
   "CHF 70부터 시작하는 보장된 고정 요금",
   "무료 항공편 추적 및 대기 시간",
   "전문 운전사, 현대적인 Mercedes 차량",
   "6개국으로의 이동: 스위스, 독일, 이탈리아, 오스트리아, 프랑스, 리히텐슈타인",
   "24/7 이용 가능 – 야간 및 공휴일에도",
   "카드, Apple Pay, Google Pay 또는 현금으로 결제"
  ],
  "cta_prices": "모든 가격 보기",
  "cta_cities": "모든 도시 및 노선"
 },
 "ckb": {
  "h2a": "نقلەکانت لە فڕۆکەخانەی زوریخ",
  "p1": "تاکسی فڕۆکەخانەی زوریخ پەرەسەندەی تایبەتی تۆ بۆ نقلەکان و خزمەتگوزاری تاکسی لە فڕۆکەخانەی زوریخ (ZRH)ە. ئیشکراوی کە ئیش دوور بگرن بەرەو پەیوەندیدانی کە بەھەفڵ بێت و پارەدان لە نرخە کڕراوی دیاری کراوەکان بەرز پارە..ە. پێشەوانە لە تاقی کەسایەتی کە باسی کەسی کار کە، مەمناکی خانووی یاخود تیشکی سکی: نقلەکت لە فڕۆکەخانەی زوریخ لە کەمتر لە یەک خولەکەدا دیاری کراوە.",
  "h2b": "تاکسی فڕۆکەخانەی زوریخ لە نرخە کڕراوی دیاری کراوە - هیچ بێدەنگی نییە",
  "p2": "بە شێوەیەکی جیاواز لە تاکسیکی عادی لە فڕۆکەخانەی زوریخ، تۆ نرخە کڕراوی دیاری کراوی پەیوەندیدانە کە پێش تۆ میوان. هیچ تاکسیمەتەرێک نییە، هیچ شگفا نییە. بە شێوەیەکی ڕوون هەڵگرتنی فڕۆکە، ئیشکراوی کاتی ئیشکردن بەرز دەکەین بۆ کەتی نمامەی خوت – و بڕیاری ئیشکرنی نائاسایی هەیە، هەر کات کە فڕۆکت تێپەڕی دەبەخن.",
  "h2c": "راپۆرتە تایبەتی بەرز ترین فڕۆکەکان لە فڕۆکەخانەی زوریخ",
  "h2d": "بۆچی تاکسی فڕۆکەخانەی زوریخ؟",
  "feats": [
   "نرخە کڕراوی دیاری کراو لەCHF 70",
   "هەڵگرتنی فڕۆکەی بێت و کاتی چاوەڕوانی بێ مەنا",
   "پێشوەرانە تایبەتی، فلیتو یان مەرسədسە",
   "نقلەکان بۆ 6 وڵات: سوئیس، ئەڵمان، ئیتاڵیا، ئیشتاریا، فڕانسه، لیختنشتاین",
   "د available 24/7 - هەروەها لە شەو و لە ڕوونا بمشتی",
   "پەرەدانی بە کارت، Apple Pay، Google Pay یان نەقد"
  ],
  "cta_prices": "بەینانی هەموو نرخیەکان",
  "cta_cities": "هەموو شەهرەکان و ڕووتەکان"
 }
};

export const RATINGS_COPY = {
 "en": {
  "eyebrow": "Real ratings",
  "title": "What our passengers say",
  "sub": "Ratings from customers after their ride.",
  "based": "from {n} reviews",
  "google": "Rate us on Google"
 },
 "fr": {
  "eyebrow": "Évaluations réelles",
  "title": "Ce que nos passagers disent",
  "sub": "Évaluations des clients après leur trajet.",
  "based": "d'après {n} avis",
  "google": "Évaluez-nous sur Google"
 },
 "it": {
  "eyebrow": "Valutazioni reali",
  "title": "Cosa dicono i nostri passeggeri",
  "sub": "Valutazioni dai clienti dopo il loro viaggio.",
  "based": "da {n} recensioni",
  "google": "Valutaci su Google"
 },
 "es": {
  "eyebrow": "Valoraciones reales",
  "title": "Lo que dicen nuestros pasajeros",
  "sub": "Valoraciones de clientes después de su viaje.",
  "based": "de {n} reseñas",
  "google": "Califícanos en Google"
 },
 "pt": {
  "eyebrow": "Avaliações reais",
  "title": "O que nossos passageiros dizem",
  "sub": "Avaliações de clientes após sua corrida.",
  "based": "de {n} avaliações",
  "google": "Avalie-nos no Google"
 },
 "tr": {
  "eyebrow": "Gerçek değerlendirmeler",
  "title": "Yolcularımız ne diyor",
  "sub": "Müşterilerin yolculuktan sonraki değerlendirmeleri.",
  "based": "{n} incelemeden",
  "google": "Bizi Google'da değerlendirin"
 },
 "ru": {
  "eyebrow": "Реальные оценки",
  "title": "Что говорят наши пассажиры",
  "sub": "Оценки от клиентов после поездки.",
  "based": "из {n} отзывов",
  "google": "Оцените нас на Google"
 },
 "ar": {
  "eyebrow": "تقييمات حقيقية",
  "title": "ماذا يقول ركابنا",
  "sub": "تقييمات من العملاء بعد رحلتهم.",
  "based": "من {n} مراجعة",
  "google": "قيمنا على جوجل"
 },
 "fa": {
  "eyebrow": "نظرات واقعی",
  "title": "نظرات مسافران ما",
  "sub": "نمرات مشتریان پس از سفرشان.",
  "based": "بر اساس {n} بررسی",
  "google": "به ما در گوگل امتیاز دهید"
 },
 "hi": {
  "eyebrow": "वास्तविक रेटिंग",
  "title": "हमारे यात्रियों का क्या कहना है",
  "sub": "उनकी सवारी के बाद ग्राहकों की रेटिंग।",
  "based": "{n} समीक्षाओं से",
  "google": "हमें Google पर रेट करें"
 },
 "zh": {
  "eyebrow": "真实评分",
  "title": "我们的乘客怎么说",
  "sub": "客户在乘车后的评分。",
  "based": "来自 {n} 条评论",
  "google": "在Google上评价我们"
 },
 "ko": {
  "eyebrow": "실제 평가",
  "title": "우리 승객들이 말하는 것",
  "sub": "승차 후 고객의 평가.",
  "based": "{n}개의 리뷰 기반",
  "google": "구글에서 평가하기"
 },
 "ckb": {
  "eyebrow": "نەخشەی ڕاستی",
  "title": "چی ئەو بەرەوپیشەکانمان وەڵام دەدەن",
  "sub": "نەخشەکان لە ڕووداوەکان کە پاش سەیرەکان لەسەر دەدەن.",
  "based": "لە {n} ڕووداوەکاندا",
  "google": "بەرزیدەوە لە گووگڵ"
 }
};

export const CHAT_COPY = {
 "en": {
  "title": "Airport Taxi Assistant",
  "sub": "We reply instantly",
  "ph": "Your question …",
  "greet": "Hello! 👋 How can I help with your airport transfer?",
  "err": "Sorry, something went wrong. Please try again or call us."
 },
 "fr": {
  "title": "Assistant de Taxi Aéroport",
  "sub": "Nous répondons instantanément",
  "ph": "Votre question …",
  "greet": "Bonjour! 👋 Comment puis-je vous aider avec votre transfert aéroport ?",
  "err": "Désolé, quelque chose a mal tourné. Veuillez réessayer ou nous appeler."
 },
 "it": {
  "title": "Assistente Taxi Aeroportuale",
  "sub": "Rispondiamo istantaneamente",
  "ph": "La tua domanda …",
  "greet": "Ciao! 👋 Come posso aiutarti con il tuo trasferimento aeroportuale?",
  "err": "Mi dispiace, qualcosa è andato storto. Per favore riprova o chiamaci."
 },
 "es": {
  "title": "Asistente de Taxi del Aeropuerto",
  "sub": "Respondemos al instante",
  "ph": "Tu pregunta …",
  "greet": "¡Hola! 👋 ¿Cómo puedo ayudar con tu traslado al aeropuerto?",
  "err": "Lo siento, algo salió mal. Por favor, inténtalo de nuevo o llámanos."
 },
 "pt": {
  "title": "Assistente de Taxi do Aeroporto",
  "sub": "Respondemos instantaneamente",
  "ph": "Sua pergunta …",
  "greet": "Olá! 👋 Como posso ajudar com seu transfer do aeroporto?",
  "err": "Desculpe, algo deu errado. Por favor, tente novamente ou nos ligue."
 },
 "tr": {
  "title": "Havalimanı Taksi Asistanı",
  "sub": "Anında yanıt veriyoruz",
  "ph": "Sorunuz …",
  "greet": "Merhaba! 👋 Havalimanı transferinizle nasıl yardımcı olabilirim?",
  "err": "Üzgünüm, bir şeyler yanlış gitti. Lütfen tekrar deneyin veya bizimle iletişime geçin."
 },
 "ru": {
  "title": "Ассистент такси в аэропорт",
  "sub": "Мы отвечаем мгновенно",
  "ph": "Ваш вопрос …",
  "greet": "Здравствуйте! 👋 Как я могу помочь с вашим трансфером из аэропорта?",
  "err": "Извините, что-то пошло не так. Пожалуйста, попробуйте еще раз или позвоните нам."
 },
 "ar": {
  "title": "مساعد تاكسي المطار",
  "sub": "نرد بسرعة",
  "ph": "سؤالك …",
  "greet": "مرحبًا! 👋 كيف يمكنني مساعدتك في نقلك من المطار؟",
  "err": "عذراً، حدث شيء خاطئ. يرجى المحاولة مرة أخرى أو الاتصال بنا."
 },
 "fa": {
  "title": "کمک‌رسان تاکسی فرودگاهی",
  "sub": "ما به سرعت پاسخ می‌دهیم",
  "ph": "سوالی دارید …",
  "greet": "سلام! 👋 چگونه می‌توانم در انتقال شما به فرودگاه کمک کنم؟",
  "err": "متأسفم، مشکلی پیش آمده است. لطفاً دوباره تلاش کنید یا با ما تماس بگیرید."
 },
 "hi": {
  "title": "एयरपोर्ट टैक्सी सहायक",
  "sub": "हम तुरंत उत्तर देते हैं",
  "ph": "आपका सवाल …",
  "greet": "नमस्ते! 👋 मैं आपकी एयरपोर्ट ट्रांसफर में कैसे मदद कर सकता हूँ?",
  "err": "क्षमा करें, कुछ गलत हो गया। कृपया पुनः प्रयास करें या हमें कॉल करें।"
 },
 "zh": {
  "title": "机场出租车助手",
  "sub": "我们会即时回复",
  "ph": "您的问题 …",
  "greet": "您好！👋 我可以如何帮助您安排机场接送？",
  "err": "抱歉，出现一些问题。请重试或致电我们。"
 },
 "ko": {
  "title": "공항 택시 도우미",
  "sub": "즉시 답변해드립니다",
  "ph": "귀하의 질문 …",
  "greet": "안녕하세요! 👋 공항 이동에 어떻게 도와드릴까요?",
  "err": "죄송합니다, 문제가 발생했습니다. 다시 시도하시거나 저희에게 전화해 주세요."
 },
 "ckb": {
  "title": "یارمەتیدەر عێرانگاهی",
  "sub": "ئێمە چەندەکان پێشەکی دەگن",
  "ph": "پێشنیازەکەتان …",
  "greet": "سڵاو! 👋 چۆن دەتوانم یارمەتیتان بدەم لەگەڵ گواستنەوەی عێرانگاهەکانت؟",
  "err": "ببورە، شتێک هەڵەیە. تکایە دوبارە ه尝ی بکە یان بەرەوپێشمان پەیوەندیم بکه."
 }
};

export const GCARD_COPY = {
 "en": {
  "title": "Rate us on Google",
  "sub": "Your feedback helps us grow.",
  "cta": "Review on Google",
  "based": "from {n} reviews"
 },
 "fr": {
  "title": "Évaluez-nous sur Google",
  "sub": "Vos retours nous aident à grandir.",
  "cta": "Laissez un avis sur Google",
  "based": "d'après {n} avis"
 },
 "it": {
  "title": "Valutaci su Google",
  "sub": "Il tuo feedback ci aiuta a crescere.",
  "cta": "Recensisci su Google",
  "based": "da {n} recensioni"
 },
 "es": {
  "title": "Califícanos en Google",
  "sub": "Tu opinión nos ayuda a crecer.",
  "cta": "Reseña en Google",
  "based": "de {n} reseñas"
 },
 "pt": {
  "title": "Avalie-nos no Google",
  "sub": "Seu feedback nos ajuda a crescer.",
  "cta": "Avaliar no Google",
  "based": "de {n} avaliações"
 },
 "tr": {
  "title": "Bizi Google'da Derecelendirin",
  "sub": "Geri bildiriminiz büyümemize yardımcı olur.",
  "cta": "Google'da Yorum Yap",
  "based": "{n} incelemeden itibaren"
 },
 "ru": {
  "title": "Оцените нас в Google",
  "sub": "Ваш отзыв помогает нам развиваться.",
  "cta": "Оставить отзыв в Google",
  "based": "на основе {n} отзывов"
 },
 "ar": {
  "title": "قيمنا على جوجل",
  "sub": "ملاحظاتك تساعدنا على النمو.",
  "cta": "مراجعة على جوجل",
  "based": "من {n} تقييم"
 },
 "fa": {
  "title": "نمره دهید به ما در گوگل",
  "sub": "بازخورد شما به ما در رشد کمک می‌کند.",
  "cta": "بررسی در گوگل",
  "based": "از {n} بررسی"
 },
 "hi": {
  "title": "गूगल पर हमारी रेटिंग करें",
  "sub": "आपकी प्रतिक्रिया हमें बढ़ने में मदद करती है।",
  "cta": "गूगल पर समीक्षा करें",
  "based": "{n} समीक्षाओं से"
 },
 "zh": {
  "title": "在谷歌上评价我们",
  "sub": "您的反馈帮助我们成长。",
  "cta": "在谷歌上评价",
  "based": "来自 {n} 条评论"
 },
 "ko": {
  "title": "구글에 리뷰 남기기",
  "sub": "고객님의 피드백이 저희를 성장하게 합니다.",
  "cta": "구글에 리뷰 쓰기",
  "based": "{n}개의 리뷰 기준"
 },
 "ckb": {
  "title": "رەیت بکە لەسەر گووگڵ",
  "sub": "پێڕستی تۆ بە ماوەیەکی زۆر حاڵەتی ماوە بەرز دەکات.",
  "cta": "بەدوای نوسین لەسەر گووگڵ",
  "based": "لە {n} سەروەردەوە"
 }
};
